import { useState, useEffect } from 'react';

interface ResponsiveState {
  isLaptop: boolean;
  isiPad: boolean;
  isiPhone: boolean;
  width: number;
}

export const useResponsive = (): ResponsiveState => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1920
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { width } = windowSize;

  return {
    isLaptop: width <= 1600,
    isiPad: width <= 1024 && width > 768,
    isiPhone: width <= 768,
    width
  };
};